jQuery(document).ready(function($){
    $('.bannerSlider').slick({
      infinite: true,
      nav: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
    });
      $('.product_slider_creative').slick({
      infinite: true,
      nav: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
    });
  /*
    $('.product_custom_sec .product .product__column-sticky ul').slick({
      infinite: true,
      nav: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
    });
    */
  /***************************** Product Page ***********************************/
       $('.color_prod_create .colorSwatchlist li').on('click', function(){
         $('.colorSwatchlist li').removeClass('active');
         var val_col = $(this).attr('data-color-val');
         var disablecolor = $(this).attr('disablecolor');
         $(this).addClass('active');
         $('.product_custom_sec .product .product__info-wrapper fieldset.js.product-form__input:nth-child(2) input[value="'+val_col+'"]').trigger('click');
       
         if(val_col == 'Black'){
           if(disablecolor != val_col){
             window.location.href = '/products/do-good-keep-going-crew-pigment-dyed-black';
           }
         }else if(val_col == 'Clay'){
            if(disablecolor != val_col){
               window.location.href = '/products/copy-of-do-good-keep-going-crew-pigment-dyed-clay';
            }
         }else if(val_col == 'Sand'){
           if(disablecolor != val_col){
             window.location.href = '/products/do-good-keep-going-crew-pigment-dyed-sand';
           }
         }else if(val_col == 'Cement'){
           if(disablecolor != val_col){
             window.location.href = '/products/copy-of-do-good-keep-going-crew-pigment-dyed-cement-1';
           }
         }
         
       }); 

      $('.accordion-item .acc_btn').on('click', function() {
    $(this).next().slideToggle();
  });   
  
});